import React from 'react'
import intl from 'react-intl-universal'
import { LOCALE } from '@foxrenderfarm/internals'
import { LightNavDropDownWrapper, ProductsLightDropDownSection } from '../../atoms'
import { ProductDesktopIcon, ProductRenderingIcon } from '../../svg'
import { LightNavDropDownPanel, MainLink, Trigger, getLocalAppOrigin, isPathActive } from './common'

interface ProductsDropDownProps {
  currentLocale: LOCALE
  currentPathname: string
  origin: string
}

export const ProductsDropDown = ({
  currentLocale,
  currentPathname,
  origin,
}: ProductsDropDownProps) => {
  const useGatsbyLink = process.env.GATSBY_PACKAGE_NAME === 'main'
  const mainOrigin = getLocalAppOrigin(origin, 8084)
  const items: {
    to: string
    label: string
    useGatsbyLink: boolean
    Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
  }[] = [
    {
      to: '/cloud-rendering.html',
      label: intl.get('index.header.products.online'),
      useGatsbyLink: true,
      Icon: ProductRenderingIcon,
    },
    {
      to: '/download.html',
      label: intl.get('index.header.products.desktop'),
      useGatsbyLink: true,
      Icon: ProductDesktopIcon,
    },
  ]
  const active = items.some((i) => isPathActive(currentPathname, i.to, currentLocale))

  return (
    <LightNavDropDownWrapper $isActive={active} $panelMinWidth={262}>
      <Trigger>{intl.get('index.header.products')}</Trigger>
      <LightNavDropDownPanel panelTitle={intl.get('index.header.products')}>
        <ProductsLightDropDownSection>
          {items.map((item) => {
            const Icon = item.Icon
            return (
              <MainLink
                key={item.to}
                to={item.to}
                href={`${mainOrigin}${item.to}`}
                useGatsbyLink={useGatsbyLink && item.useGatsbyLink}
                locale={currentLocale}
                $highlight={isPathActive(currentPathname, item.to, currentLocale)}
                className='products-main-link'
              >
                {Icon && <Icon style={{ marginRight: 8 }} />}
                {item.label}
              </MainLink>
            )
          })}
        </ProductsLightDropDownSection>
      </LightNavDropDownPanel>
    </LightNavDropDownWrapper>
  )
}
